
import { createRoot } from 'react-dom/client';
import App from './main';
import './../src/index.css';

createRoot(document.getElementById('app')!)
    .render(<App />);